import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { StyledBackgroundDiv } from "../../styles/common.style";
import SeoHelmet from "./SeoHelmet";
import AvailableViews from "../../enums/views";

const NotFoundPage = () => {
    return (
        <StyledBackgroundDiv>
            <SeoHelmet
                title="DJ Mayday | Page introuvable"
                description="Cette page n'existe pas."
                url="https://www.djmayday.com"
                noIndex
            />
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "0 20px",
                }}
            >
                <Typography sx={{ fontSize: { xs: "5rem", md: "8rem" }, fontWeight: 900, color: "primary.main" }}>
                    404
                </Typography>
                <Typography sx={{ fontSize: { xs: "1.2rem", md: "1.5rem" }, color: "primary.main", marginBottom: "40px" }}>
                    Oups, cette page n'existe pas... mais la fête continue ailleurs !
                </Typography>
                <Button
                    component={Link}
                    to={AvailableViews.Main}
                    sx={{ border: "1px solid", borderColor: "primary.main" }}
                >
                    Retour à l'accueil
                </Button>
            </Box>
        </StyledBackgroundDiv>
    );
};

export default NotFoundPage;
